/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Table, Tag, Divider, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import {
  Receipt,
  DownloadReceiptPayload,
} from 'utils/apiClient/services/rksv/types';

interface Props {
  receipts: Array<Receipt>;
  loading: boolean;
  download?: (options: DownloadReceiptPayload) => void;
  showDownload?: boolean;
}

const LogTable: React.FC<Props> = ({
  loading,
  receipts,
  download,
  showDownload = true,
}) => {
  const columns = [
    {
      title: <FormattedMessage defaultMessage="Number" />,
      dataIndex: ['rawReceipt', 'data', 'receiptNumber'],
      key: 'number',
    },
    {
      title: <FormattedMessage defaultMessage="Date" />,
      dataIndex: ['rawReceipt', 'data', 'date'],
      key: 'date',
    },
    {
      title: <FormattedMessage defaultMessage="Net price" />,
      dataIndex: ['rawReceipt', 'data', 'totalDiscountedNetto'],
      key: 'total_price',
    },
    {
      title: <FormattedMessage defaultMessage="Tax" />,
      dataIndex: ['rawReceipt', 'data', 'taxesDiscountedSum'],
      key: 'tax',
    },
    {
      title: (
        <FormattedMessage
          defaultMessage="Total"
          description="final price rksv logs"
        />
      ),
      dataIndex: ['rawReceipt', 'data', 'finalPrice'],
      key: 'final_price',
    },
    {
      title: <FormattedMessage defaultMessage="Status" />,
      key: 'tags',
      render: (r: Receipt) => (
        <Tag
          color={r.last_signature_status !== 'signed' ? 'volcano' : 'green'}
          key={r.last_signature_status}
        >
          {r.last_signature_status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: <FormattedMessage defaultMessage="Downloads" />,
      key: 'downloads',
      render: (r: Receipt) => (
        <span>
          {r.receiptLinks && (
            <>
              <Button
                data-testid="pdf-download"
                onClick={() => {
                  if (download) {
                    download({
                      orderId: r.rawReceipt.data.order_id,
                      fileName: r.rawReceipt.data.receiptNumber,
                      fileFormat: 'application/pdf',
                    });
                  }
                }}
              >
                PDF
              </Button>
              <Divider type="vertical" />
              <Button
                data-testid="image-download"
                onClick={() => {
                  if (download) {
                    download({
                      orderId: r.rawReceipt.data.order_id,
                      fileName: r.rawReceipt.data.receiptNumber,
                      fileFormat: 'image/png',
                    });
                  }
                }}
              >
                Image
              </Button>
            </>
          )}
        </span>
      ),
    },
  ];

  if (!showDownload) {
    columns.pop();
  }
  return (
    <Table<Receipt>
      size="middle"
      pagination={false}
      columns={columns}
      loading={loading}
      rowKey={(r) => r._id}
      dataSource={receipts}
      css={`
        .ant-table-placeholder {
          min-height: calc(100vh - 300px);
        }
      `}
    />
  );
};

export default LogTable;
